import { Injectable } from '@angular/core';
import { AbstractSaveOneService } from 'src/app/modules/core/service/v2/service/save/abstractSaveOne.service';
import {PayloadV2} from "../../../../../core/service/payload/payloadV2";
import {AudioTranscriptionRepository} from "../../impl/service/ngrx/audioTranscription.repository";
import {AudioTranscriptionDataServiceAdapter} from "../../impl/service/ngrx/audioTranscriptionDataService.adapter";
import {AudioTranscriptionModel} from "../model/audioTranscription.model";

@Injectable()
export class AudioTranscriptionSaveService extends AbstractSaveOneService<AudioTranscriptionModel, AudioTranscriptionSave> {

    constructor(repository: AudioTranscriptionRepository, dataServiceAdapter: AudioTranscriptionDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}

export class AudioTranscriptionSave extends PayloadV2 {
    audioRecordId: number | string;
    transcription: string;
    context: string;
    providerValue: string;
}
